import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import BackButton from '@swf/components/StarsModal/components/BackButton';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import { select } from '@swf/core/store';

import styles from './NotificationContainer.scss';

export interface Props {
  title?: React.ReactNode;
  backButton?: boolean;
  onBack?: () => void;
  bodyClass?: string;
  hideCloseButton?: boolean;
  onClose?(): void;
}

const NotificationContainer: React.FC<Props> = ({
  title,
  onClose,
  children,
  onBack,
  backButton = false,
  bodyClass,
  hideCloseButton
}) => {
  const isMobileEmbedded = useSelector(select.site.isMobileEmbedded);

  return (
    <>
      {title && !isMobileEmbedded && (
        <Header>
          {backButton && <BackButton onClick={onBack} />}
          {title}
          {!hideCloseButton && <CloseButton onClick={onClose} />}
        </Header>
      )}
      <Body className={classNames(bodyClass, styles.modalBody)}>{children}</Body>
    </>
  );
};
export default NotificationContainer;
